/**
 * 功能说明：用于处理ws消息推送相关的内容
 */
import { setMsgReadStatus, callOut, contactSolve, delayRemind } from "@/api/index";
import Notification from '@/components/notify'
import i18n from '@/i18n'
export default {
  mounted() {
    window.look_ticket = this.look_ticket;
    window.look_announce = this.look_announce;
    window.laterImmediately = this.laterImmediately;
    window.laterRemind = this.laterRemind;
    window.open_tab = this.open_tab;
    window.addEventListener("message", this.openTypeEvents)
  },
  beforeDestroy() {
    window.removeEventListener("message", this.openTypeEvents)
  },
  methods: {
    openTypeEvents(e) {
      try {
        const { type, data = {} } = e.data;
        const { url, title } = data
        if (type == "open_tab") {
          this.open_tab(url, title)
        }
      } catch (error) { }
    },
    // 更新消息已读状态
    updateMsgReadStatus(message_id) {
      if (message_id) {
        setMsgReadStatus({
          message_id
        }).finally((err) => {
          this.updateUnReadMsgCount();
        });
      }
    },
    // 广播通知更新消息数量
    updateUnReadMsgCount() {
      this._Bus.$emit("updateUnReadMsgCount");
    },
    /**
     * 工单消息处理:由于推送的消息是原生事件，所以需要挂在到windows上去
     * */
    look_ticket(elm) {
      let ticket_no = elm.dataset["value"] || "";
      let flow_id = elm.dataset["flow"] || 0;
      let menu_id = elm.dataset["menu"] || 0;

      // 这里获取到当前元素的下一个存储messageId的input框元素，取出input框，然后标记消息为已读
      let nextInput = elm.parentElement.getElementsByClassName("message_id");
      if (nextInput.length > 0) {
        let message_id = nextInput[nextInput.length - 1].value;
        if (message_id != "") {
          this.updateMsgReadStatus(message_id);
        }
      }

      const {
        ticket: {
          ticket_page = ''
        } = {}
      } = this._config.URL || {}
      if (ticket_no != "" && flow_id != 0 && ticket_page) {
        let title = i18n.t('mixins.ticketView') + ticket_no + "";
        let addTabItem = {
          key: String(title),
          name: title,
          url: `${ticket_page}/setting/ticket_settings_check/${flow_id}/${menu_id}/${ticket_no}`,
        };

        this.addTab(addTabItem);
      }
    },
    /**
         * 新工单消息处理:由于推送的消息是原生事件，所以需要挂在到windows上去
         * */
    open_tab(url, title) {
      const addTabItem = {
        key: String(title),
        name: title,
        url,
      };
      this.addTab(addTabItem);
    },

    // 查看公告：推送的消息是原生事件，所以需要挂在到windows上去
    look_announce(elm) {
      let message_id = elm.dataset["msgid"] || "";
      let anns_id = elm.dataset["mark"] || "";
      const {
        my: {
          ektv3_page
        }
      } = this._config.URL;
      if (anns_id && ektv3_page) {
        this.updateMsgReadStatus(message_id);

        this.changeDrawerInfo({
          title: i18n.t('mixins.announcementDetail'),
          drawerShow: true,
          drawerSrc: `${ektv3_page}/ekt/announce/details/${anns_id}`,
          drawerWidth: 600,
        });
      }
    },
    /**
     * 提醒消息框-立即联系客户
     * 1-呼出电话; 2-弹出业务受理; 3-更改稍后联系状态
     * @param cle_id 客户id
     * @param phone 客户电话
     * @param later_id 稍后联系id
     *
     */
    laterImmediately(cle_id, phone, later_id) {
      const { my: { ektv3_page }, } = this._config.URL;
      var _phone = String(phone);
      var _clientId = String(cle_id);
      const params = {
        'phone': _phone,
        'client_id': _clientId
      }
      callOut(ektv3_page, params).then((resp) => {
        if (resp.code == 0) {
          var _callId = resp.data.callId;
          const params = {
            'id': later_id,
            'call_id': _callId
          }
          contactSolve(ektv3_page, params).then(resp => {
            if (resp.code == 0) {
              // 关闭提示窗口
              Notification.closeAll()
              return false;
            }
          })
        }
      });
    },

    /**
     * 提醒消息框-稍后提醒
     *
     * @param later_id 稍后联系id
     * @param delay_min 延迟分钟数
     *
     */
    laterRemind(later_id, delay_min) {
      const { my: { ektv3_page }, } = this._config.URL;
      var delay_sec = delay_min * 60;
      const params = {
        'id': later_id,
        'delay_sec': delay_sec
      }
      delayRemind(ektv3_page, params).then(resp => {
        if (resp.code == 0) {
          // 关闭提示窗口
          Notification.closeAll()
          return false;
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/wsMsg.js